import React from "react";
import { Handle, Position } from "@xyflow/react";
import { useTranslation } from "react-i18next";
import { HoverTooltip } from "../../common/HoverTooltip";

// Technology initials, e.g. "EarthRanger" -> "ER", "SMART Connect" -> "SC".
const initials = (name?: string) =>
    (name || "?").split(/[\s-]+/).filter(Boolean).slice(0, 2).map((w) => w[0].toUpperCase()).join("");

const AccountNode = ({ data }: any) => {
    const { t } = useTranslation();
    return (
        <HoverTooltip content={t("Configure Integration")} position="top" portal focusable={false} className="block">
        <div className={`border rounded-lg bg-white px-4 py-3 w-[260px] cursor-pointer transition-shadow hover:shadow-md ${
            data.isSelected ? "border-connection-green ring-2 ring-connection-green" : "border-gray-lines"}`}>
            <div className="flex items-center gap-2">
                <span className="flex-none w-7 h-7 rounded bg-light-green text-connection-green text-[11px] font-bold flex items-center justify-center">
                    {initials(data.techName)}
                </span>
                <span className="text-off-black font-semibold truncate" title={data.name}>{data.name}</span>
                {/* checklist state: every required field saved (✓) or setup pending (!) */}
                <span className={`ml-auto flex-none w-4 h-4 rounded-full text-[10px] font-bold flex items-center justify-center ${
                    data.needsSetup ? "bg-orange-50 text-orange border border-orange-200" : "bg-light-green text-connection-green"}`}
                    title={data.needsSetup ? t("Needs setup — required fields are missing") : t("Configured")}>
                    {data.needsSetup ? "!" : "✓"}
                </span>
            </div>
            <div className="text-xs text-secondary-text truncate mt-1" title={data.base_url}>{data.base_url || t("No URL")}</div>
            <div className="flex items-center gap-2 mt-1.5">
                {/* min-w-0 + truncate keeps a long role label on one line, and the
                    pill never wraps — the card height stays fixed. */}
                <span className="min-w-0 truncate text-[11px] uppercase tracking-wider text-medium-gray font-semibold">
                    {data.roleLabel}
                </span>
                {data.hasRules && (
                    <span className="flex-none whitespace-nowrap bg-light-green text-connection-green rounded-full px-2 py-0.5 text-[11px] font-semibold">{t("Field mapping")}</span>
                )}
            </div>

            {data.isProvider ? (
                <>
                    <Handle type="source" id="out-source" position={Position.Right} isConnectable={false}
                        className="opacity-0" style={{ top: "35%" }} />
                    <Handle type="target" id="in-target" position={Position.Right} isConnectable={false}
                        className="opacity-0" style={{ top: "65%" }} />
                </>
            ) : (
                <>
                    <Handle type="target" id="out-target" position={Position.Left} isConnectable={false}
                        className="opacity-0" style={{ top: "35%" }} />
                    <Handle type="source" id="in-source" position={Position.Left} isConnectable={false}
                        className="opacity-0" style={{ top: "65%" }} />
                </>
            )}
        </div>
        </HoverTooltip>
    );
};

export default AccountNode;
